var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#2C87DE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6665 23.6666H28.3332C24.3332 23.6666 21.6665 25.6666 21.6665 30.3333V39.6666C21.6665 44.3333 24.3332 46.3333 28.3332 46.3333H41.6665C45.6665 46.3333 48.3332 44.3333 48.3332 39.6666V30.3333C48.3332 25.6666 45.6665 23.6666 41.6665 23.6666ZM42.2932 31.7866L38.1198 35.12C37.2398 35.8266 36.1198 36.1733 34.9998 36.1733C33.8798 36.1733 32.7465 35.8266 31.8798 35.12L27.7065 31.7866C27.2798 31.44 27.2132 30.8 27.5465 30.3733C27.8932 29.9466 28.5198 29.8666 28.9465 30.2133L33.1198 33.5466C34.1332 34.36 35.8532 34.36 36.8665 33.5466L41.0398 30.2133C41.4665 29.8666 42.1065 29.9333 42.4398 30.3733C42.7865 30.8 42.7198 31.44 42.2932 31.7866Z",
    fill: "#2C87DE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailicon);
export default __webpack_public_path__ + "static/media/emailicon.836c0bacdc0030521e1703a03a052e45.svg";
export { ForwardRef as ReactComponent };